import * as THREE from "three";
import { lib } from "./views";
import { SceneRig } from "./scene";
import { Cell, Grid, Heading } from "@highmarch/domain";

/**
 * Readability sheet (P0.6.5): every loaded model at gameplay camera distance on one ground, labelled by index in the
 * console, so a single screenshot shows which assets read consistently. Opened with `?sheet`.
 */
export function showReadabilitySheet(rig: SceneRig, uiRoot: HTMLElement): void {
  const L = lib();
  if (!L) return;
  const all: string[] = [];
  for (const n of ["tower_arrow_t1", "tower_cannon_t1", "tower_tesla_t1", "tower_mortar_t1", "base_t1", "troop_soldier", "enemy_raider", "p_tree_pine_s", "p_rocks", "g_grass0", "g_path_straight", "g_path_corner", "g_path_end"]) if (L.hq(n)) all.push(`hq:${n}`);
  const ground = L.hq("g_grass0") ? "hq:g_grass0" : null;
  const cols = 8, gap = 1.6;
  const rows = Math.ceil(all.length / cols);
  const group = new THREE.Group();
  for (let i = 0; i < all.length; i++) {
    const cx = (i % cols) * gap, cz = (rows - 1 - Math.floor(i / cols)) * gap;
    if (ground && all[i] !== ground) {
      const g = L.clone(ground);
      g.position.set(cx, 0, cz);
      group.add(g);
    }
    const m = L.clone(all[i]);
    m.position.set(cx, 0, cz);
    group.add(m);
  }
  rig.scene.add(group);
  const w = Math.ceil(cols * gap) + 1, h = Math.ceil(rows * gap) + 1;
  rig.frame(new Grid(w, h, new Cell(0, 0), Heading.North, []));
  rig.focusCell(new Cell((cols - 1) * gap / 2, (rows - 1) * gap / 2));
  rig.onPinch(0.42);
  const label = document.createElement("div");
  label.className = "sheetlabel";
  label.textContent = `Readability sheet — ${all.length} models, ${cols} per row, bottom-left first: ${all.join(", ")}`;
  uiRoot.append(label);
  console.log("readability sheet order:", all);
}
